/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    salutation?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    zipcode: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    country: string;
}

/**
 * Check if a given object implements the Address interface.
 */
export function instanceOfAddress(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "street" in value;
    isInstance = isInstance && "zipcode" in value;
    isInstance = isInstance && "city" in value;
    isInstance = isInstance && "country" in value;

    return isInstance;
}

export function AddressFromJSON(json: any): Address {
    return AddressFromJSONTyped(json, false);
}

export function AddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): Address {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'salutation': !exists(json, 'salutation') ? undefined : json['salutation'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'street': json['street'],
        'zipcode': json['zipcode'],
        'city': json['city'],
        'country': json['country'],
    };
}

export function AddressToJSON(value?: Address | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'salutation': value.salutation,
        'title': value.title,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'companyName': value.companyName,
        'street': value.street,
        'zipcode': value.zipcode,
        'city': value.city,
        'country': value.country,
    };
}

